// Texts of Relatórios › Receitas e despesas mensais (15/10/2026).
export default {
  monthly: {
    title: 'Receitas e despesas mensais',
    subtitle: 'Acompanhe entradas e saídas por categoria e consulte os lançamentos que compõem cada total.',
    basis: 'Inclui lançamentos em aberto e liquidados, pela data de ocorrência (no cartão, {card}). Não é o saldo das contas nem só o que já entrou ou saiu do banco.',
    basisCard: { invoice: 'pelo vencimento da fatura', purchase: 'pela data da compra' },
    filters: {
      label: 'Filtros',
      preset: 'Período',
      from: 'Mês inicial',
      to: 'Mês final',
      accounts: 'Contas e cartões',
      categories: 'Categorias',
      cardBasis: 'Compras no cartão',
      inactive: 'Incluir histórico de contas inativas',
      inactiveHint: 'Os lançamentos das contas inativas são acrescentados ao que está escolhido.',
      noAccount: 'Sem conta',
      uncategorized: 'Sem categoria',
      selectAll: 'Selecionar todas',
      clear: 'Limpar seleção',
      search: 'Buscar categoria',
      selectedAll: 'Todas',
      selectedNone: 'Nenhuma',
      selectedSome: '{n} de {total}',
      inactiveTag: 'inativa',
    },
    presets: {
      current: 'Mês atual',
      last3: 'Últimos 3 meses',
      last6: 'Últimos 6 meses',
      last12: 'Últimos 12 meses',
      year: 'Ano atual',
      lastYear: 'Ano anterior',
      custom: 'Personalizado',
    },
    cardBasis: { invoice: 'Por vencimento da fatura', purchase: 'Por data da compra' },
    cardBasisShort: { invoice: 'Pela data da fatura', purchase: 'Pela data da compra' },
    periodErrors: {
      fromRequired: 'Escolha o mês inicial.',
      toRequired: 'Escolha o mês final.',
      fromAfterTo: 'O mês inicial não pode ser posterior ao final.',
      tooLong: 'Escolha um período de até {max} meses (o escolhido tem {n}).',
    },
    summary: { income: 'Receitas', expense: 'Despesas', result: 'Resultado', resultHint: 'Receitas − despesas do período. Não é saldo disponível.', count: '{n} lançamentos' },
    sections: { income: 'Entradas', expense: 'Saídas', result: 'Resultado', total: 'Total', category: 'Categoria' },
    matrixTitle: 'Por categoria e mês',
    expandAll: 'Expandir tudo',
    collapseAll: 'Recolher tudo',
    toggle: 'Abrir ou fechar {name}',
    open: 'Ver lançamentos de {name}',
    openMonth: 'Ver só os lançamentos de {month}',
    inactiveCategory: 'inativa',
    export: 'Exportar CSV',
    exportMeta: {
      company: 'Empresa',
      period: 'Período',
      accounts: 'Contas consideradas',
      inactive: 'Histórico de contas inativas',
      basis: 'Base de data',
      pending: 'Lançamentos em aberto',
      pendingValue: 'Incluídos',
      currency: 'Moeda',
      generated: 'Gerado em',
      yes: 'Incluído',
      no: 'Não incluído',
      noAccount: 'Sem conta',
    },
    warnings: {
      cardWithoutInvoice: '{n} compra(s) no cartão sem vínculo com a fatura entraram pelo ciclo do cartão. Vale conferir.',
      invalidCategory: '{n} lançamento(s) com categoria inválida estão em "Categoria inválida (revisar)".',
    },
    states: {
      noAccounts: 'Nenhuma conta selecionada',
      noAccountsHint: 'Escolha ao menos uma conta, cartão ou "Sem conta" para ver a análise.',
      noCategories: 'Nenhuma categoria selecionada',
      noCategoriesHint: 'Escolha ao menos uma categoria para ver a análise.',
      empty: 'Nenhum lançamento no período',
      emptyHint: 'Não há receitas nem despesas com estes filtros.',
      invalidPeriod: 'Período inválido',
      loadError: 'Não foi possível carregar a análise',
      loadErrorHint: 'Os valores não foram calculados. Tente de novo.',
    },
    detail: {
      close: 'Fechar',
      nature: { income: 'Receitas', expense: 'Despesas' },
      count: 'Nenhum lançamento | 1 lançamento | {n} lançamentos',
      sum: 'Soma',
      lineTotal: 'Total da linha',
      columns: { date: 'Data considerada', description: 'Descrição', category: 'Categoria', account: 'Conta / cartão', amount: 'Valor' },
      installment: 'Parcela {n}/{total}',
      occurrence: 'Recorrência · ocorrência {n}',
      invoice: 'Compra em {date} · fatura {due}',
      purchase: 'Fatura {due}',
      noInvoice: 'Sem vínculo com a fatura',
      credit: 'Estorno',
      edit: 'Editar',
      editLabel: 'Editar {name}',
      select: 'Selecionar {name}',
      selectPage: 'Selecionar os desta página',
      selectAll: 'Selecionar todos os {n}',
      clearSelection: 'Limpar seleção',
      selectedPage: '{n} selecionado(s) nesta página.',
      selectedAllPages: 'Todos os {n} lançamentos deste detalhamento estão selecionados.',
      selected: '{n} selecionado(s).',
      truncated: 'O detalhamento tem mais de {max} lançamentos: a seleção de todos vai até {max}.',
      target: 'Nova categoria',
      targetPlaceholder: 'Escolha a categoria',
      apply: 'Alterar categoria',
      confirmTitle: 'Alterar a categoria de {n} lançamento(s)?',
      confirmText: 'Destino: {category}. Escopo: só os lançamentos selecionados deste detalhamento ({line}, {period}). Valores, datas, contas e liquidações não mudam; as demais parcelas e ocorrências ficam como estão.',
      confirm: 'Alterar',
      done: 'Categoria alterada em {n} lançamento(s).',
      empty: 'Nenhum lançamento nesta linha com os filtros atuais.',
      previous: 'Anterior',
      next: 'Próxima',
      page: 'Página {page} de {pages}',
      loadError: 'Não foi possível carregar os lançamentos desta linha.',
    },
  },
}
